import React from 'react'
import { useCandidateChat } from './CandidateChatContext'
import CoachSelectionList from './SelectCoach/CoachSelectionList'
import Chat from './Chat'
import ChatEnded from './ChatEnded/index'
import MissedCall from './MissedCall/index'
import CallCancelled from './CallCancelled/index'

const CandidateChatInner = () => {
  const {
    currentView,
    candidateCoachChatSurveyPath,
    afterChatPath,
    deloitteUser = false,
  } = useCandidateChat()

  return (
    <div id="main" className="relative h-full w-full">
      {/* Overlay background */}
      <div
        id="overlay_back"
        className="z-5 tw-hidden fixed inset-0 bg-black bg-opacity-60"
      ></div>

      {/* Render based on current view */}
      {currentView === 'select_coach' && <CoachSelectionList />}
      {currentView === 'chat' && <Chat />}
      {currentView === 'call_missed' && (
        <MissedCall
          candidateCoachChatSurveyPath={candidateCoachChatSurveyPath}
          afterChatPath={afterChatPath}
          deloitteUser={deloitteUser}
        />
      )}
      {currentView === 'chat_ended' && (
        <ChatEnded
          candidateCoachChatSurveyPath={candidateCoachChatSurveyPath}
          afterChatPath={afterChatPath}
          deloitteUser={deloitteUser}
        />
      )}
      {currentView === 'call_cancelled' && (
        <CallCancelled afterChatPath={afterChatPath} />
      )}
    </div>
  )
}

export default CandidateChatInner
